import { CallEmsApi, iEmsApiResponse, iEmsApiResponseBody } from "../Logic/TenantAPI";

export interface iDataColumn {
    id: number;
    name: string;
}

export interface iCategory {
    id: number;
    name: string;
    forgroundColour: string;
}

export interface iCategoriesResponse {
    categories: iCategory[];
}

export async function GetCategories(tenantToken: string): Promise<iEmsApiResponseBody<iCategoriesResponse>> {
    return await CallEmsApi<iCategoriesResponse>(tenantToken, "GET", `Categories`);
}

export async function UpdateCategory(
    tenantToken: string,
    category: iCategory,
): Promise<iEmsApiResponseBody<iCategory>> {
    return await CallEmsApi<iCategory>(tenantToken, "PUT", `Categories/${category.id}`, category);
}

export async function CreateCategory(
    tenantToken: string,
    category: iCategory,
): Promise<iEmsApiResponseBody<iCategory>> {
    return await CallEmsApi<iCategory>(tenantToken, "POST", `Categories`, category);
}

export async function DeleteCategory(tenantToken: string, id: number): Promise<iEmsApiResponseBody<any>> {
    return await CallEmsApi<any>(tenantToken, "DELETE", `Categories/${id}`);
}

export interface iTemplate {
    id: number;
    name: string;
    sourceID: number;
    subject: string;
    body: string;
    include: string;
    actions: number[];
    mailboxes: number[];
    updatedAt: Date;
}

export async function GetTemplate(tenantToken: string, id: number): Promise<iEmsApiResponseBody<iTemplate>> {
    return await CallEmsApi<iTemplate>(tenantToken, "GET", `Config/Template/${id}`);
}

export async function UpdateTemplate(
    tenantToken: string,
    template: iTemplate,
): Promise<iEmsApiResponseBody<iTemplate>> {
    template.body = template.body.replace(/&lt;/g, "<");
    template.body = template.body.replace(/&gt;/g, ">");
    return await CallEmsApi<iTemplate>(tenantToken, "PUT", `Config/Template/${template.id}`, template);
}

export async function CreateTemplate(
    tenantToken: string,
    template: iTemplate,
): Promise<iEmsApiResponseBody<iTemplate>> {
    return await CallEmsApi<iTemplate>(tenantToken, "POST", `Config/Template/`, template);
}

export async function DeleteTemplate(tenantToken: string, id: number): Promise<iEmsApiResponseBody<any>> {
    return await CallEmsApi<any>(tenantToken, "DELETE", `Config/Template/${id}`);
}
